export default {
    LEFT: "LEFT",
    CENTER: "CENTER",
    RIGHT: "RIGHT",
    SPLIT: "SPLIT"
}
